<template>
    <div class="button-container">
        <div class="buttons">
            <input
                v-if="showBackButton"
                type="button"
                value="Back"
                class="btn btn-secondary brfss-button"
                v-on:click="backClicked"
                title="Back"
            />
            <input
                id="next-button"
                type="button"
                :value="nextButtonValue ? nextButtonValue : 'Next'"
                class="btn btn-primary brfss-button"
                v-on:click="nextClicked"
                :title="nextButtonTitle ? 'Next' : nextButtonTitle"
            />
        </div>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */

import current from '@/scripts/current';
import commonModelHelper from '@/scripts/commonModelHelper';
import { mapGetters, mapState } from 'vuex';
import store from '@/store';
import metricsHelper from '@/scripts/metricsHelper';

export default {
    computed: {
        ...mapState({
            isReadyForNextStep: (state) => state.selModel.isReadyForNextStep
        }),
        ...mapGetters({
            executionStats: 'selModel/getExecutionStats'
        })
    },
    props: ['nextButtonValue', 'nextButtonTitle'],
    data: function () {
        var vm = this;
        store.dispatch('selModel/setReadyForNextStep');
        return {
            selectionModel: current.selectionModel,
            router: vm.$router,
            showBackButton: current.selectionModel.currentStep !== 'years',
            current
        };
    },
    // watch: /*deep*/ {
    //     selectedLevelsControl1: {
    //         handler: function () {
    //             this.$emit('input', this.selectedLevels);
    //         },
    //         deep: true
    //     }
    // },
    methods: {
        pageLoaded: function (name) {
            //We are doing nothing on page load ,as WEAT uses custom navigation events
        },
        nextClicked: function (event) {
            var vm = this;
            store.dispatch('selModel/setReadyForNextStep');
            //console.log('abcd', current.selectionModel.currentStep, current.selectionModel.currentStep === 'statistics' || current.selectionModel.currentStep === 'setReference', (vm.executionStats.seconds > 60 && (current.selectionModel.currentStep === 'statistics' || current.selectionModel.currentStep === 'setReference')));
            if (!vm.isReadyForNextStep) return;
            if (
                vm.executionStats.seconds > 120 &&
                current.selectionModel.currentStep !== 'years'
            ) {
                store.dispatch('display/setErrorMessage', {
                    message:
                        'The analysis you requested will take too long to finish and will not produce any output. Try decreasing the complexity of the analysis by limiting the number of selected years, locations, or variables.',
                    messageTitle: 'Long Running Analysis'
                });
                return;
            }
            if (
                vm.executionStats.seconds > 60 &&
                (current.selectionModel.currentStep === 'statistics' ||
                    current.selectionModel.currentStep === 'setReference')
            ) {
                store.dispatch('display/setWarningMessage', {
                    message:
                        'The analysis you requested will take over one minute to finish.  To reduce completion time, try decreasing the complexity of the analysis by limiting the number of selected years, locations, or variables.',
                    messageTitle: 'Long Running Analysis'
                });
                return;
            }
            commonModelHelper.continueToNextPage(vm.$router);
        },
        backClicked: function () {
            var vm = this;
            metricsHelper.back();
            vm.$router.push({ path: current.navigation.getPreviousPage() });
        }
    }
};
</script>

<style scoped>
.button-container {
    width: 100%;
    overflow: auto;
}
.buttons {
    margin-top: 10px;
    overflow: hidden;
    /* width: 490px; */
    float: right;
}

input[type='button'] {
    width: 45%;
    font-weight: 800;
    width: 220px;
    /* float: right; */
}

button:disabled,
button[disabled] {
    font-weight: 400;
    background-color: Transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    width: 40%;
}

@media only screen and (min-width: 1280px) {
}

@media only screen and (min-width: 992px) and (max-width: 1279px) {
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
}

@media only screen and (max-width: 767px) {
    .buttons {
        width: 100%;
    }
}

@media only screen and (max-width: 540px) {
    input[type='button'] {
        width: 100%;
        max-width: inherit;
        margin: 0 0 10px 0;
    }
}
</style>
